import { useDispatch } from 'react-redux';
import { useBackendFilterPayload } from '../ducks/dashboard-reports/hooks';
import { getOverriddenReportsFromAPIThunk } from '../ducks/dashboard-reports/thunks';
export const useRefreshDashboard = dashboardId => {
  const dispatch = useDispatch();
  const currentAppliedFiltersBackendPayload = useBackendFilterPayload(dashboardId);
  return (callback = () => {}) => {
    dispatch(getOverriddenReportsFromAPIThunk(currentAppliedFiltersBackendPayload)).catch(console.error).finally(callback);
  };
};